import { usePresence } from './usePresence.js'

// PresenceBar shows the avatars of other users currently on this character —
// the Google-Docs-style "who's here" indicator (ENG-539 Stage 1). Renders
// nothing when nobody else is present.
export default function PresenceBar({ characterId }) {
  const { roster } = usePresence(characterId)
  if (!roster.length) return null

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 6 }}
      title={`${roster.length} other ${roster.length === 1 ? 'person' : 'people'} editing this character`}
    >
      <div style={{ display: 'flex' }}>
        {roster.slice(0, 6).map((p, i) => (
          <span
            key={p.userId}
            title={p.name}
            style={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              background: p.color || '#888',
              color: '#fff',
              fontSize: 11,
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid var(--panel-bg, #1e1e1e)',
              marginLeft: i === 0 ? 0 : -8,
              textTransform: 'uppercase',
            }}
          >
            {initials(p.name)}
          </span>
        ))}
      </div>
      {roster.length > 6 && <span style={{ fontSize: 12, opacity: 0.7 }}>+{roster.length - 6}</span>}
    </div>
  )
}

function initials(name) {
  const s = String(name || '?').trim()
  const at = s.indexOf('@')
  const base = at > 0 ? s.slice(0, at) : s
  const parts = base.split(/[.\s_-]+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0])
  return base.slice(0, 2)
}
